module.exports = __webpack_public_path__ + "img/member.5677d52f.svg";